module.exports = __webpack_public_path__ + "static/media/tournaments-history-menu-icon.bfe1efa9.svg";